import React, { createContext, useContext } from 'react';

interface SessionStateContextType {
  hasSession: boolean;
}

const SessionStateContext = createContext<SessionStateContextType>({
  hasSession: false,
});

export const SessionStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <SessionStateContext.Provider value={{
      hasSession: false,
    }}>
      {children}
    </SessionStateContext.Provider>
  );
};

export const useSessionState = () => useContext(SessionStateContext);
